import { useEffect, useState } from 'react';
import { getPublicAuthSettings, type PublicAuthSettingsResponse } from '../api/authSettings';
import { mergeAuthenticationSettings } from '../utils/authenticationSettings';
import { defaultAuthenticationSettings } from '../data/mockData';

/** Server-backed admin auth flags (2FA, CAPTCHA) for login flows. */
export function usePublicAuthSettings() {
  const [settings, setSettings] = useState<PublicAuthSettingsResponse>(() => ({
    adminAuth: {
      enableTwoFA: defaultAuthenticationSettings.adminAuth.enableTwoFA,
      enableCaptcha: defaultAuthenticationSettings.adminAuth.enableCaptcha !== false,
    },
  }));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const remote = await getPublicAuthSettings();
        if (!alive) return;
        setSettings(remote);
        try {
          const raw = localStorage.getItem('authenticationSettings');
          const local = raw ? JSON.parse(raw) : {};
          localStorage.setItem(
            'authenticationSettings',
            JSON.stringify(
              mergeAuthenticationSettings({
                ...local,
                adminAuth: { ...(local.adminAuth || {}), ...(remote.adminAuth || {}) },
              }),
            ),
          );
        } catch {}
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const adminTwoFaEnabled = settings.adminAuth?.enableTwoFA === true;
  const adminCaptchaEnabled = settings.adminAuth?.enableCaptcha !== false;

  return { settings, loading, adminTwoFaEnabled, adminCaptchaEnabled };
}
